//
// RouteInfo.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import EventDispatcher from "../events/EventDispatcher";
import "../lib";
import "./RoutingMode";
import "./MapUnits";
import "./DriveTimeTrafficType";

var RouteInfo = createModule("commons::RouteInfo", [], EventDispatcher, [
    ,
    ,
    ,
    {
        mode: 4,
        amount: 5,
        breaks: [5],
        hour: 4,
        trafficType: 4,
        units: 4,
        day: 4,
        minute: 4,
    },
    ,
    {
        _create: [4],
    },
    ,
]);
export default RouteInfo;
